const Rate = (props) => (
  <svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
    <path d='M14.3497 8.81536L14.4673 9.0923L14.767 9.11815L20.7801 9.63666L16.2223 13.5924L15.9949 13.7897L16.0629 14.0829L17.4258 19.9608L12.2584 16.8419L12 16.686L11.7416 16.8419L6.57613 19.9596L7.94693 14.0836L8.01549 13.7897L7.78739 13.5921L3.22308 9.63803L9.23227 9.12821L9.5327 9.10272L9.65036 8.82511L12.0003 3.28048L14.3497 8.81536Z' />
  </svg>
);

export default Rate;
